import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';
import Config from './general/config';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { UnsavedChangesProvider } from './general/unsaved-changes';
import { PrimeReactProvider } from 'primereact/api';
import { FullscreenOverlayProvider } from './providers/fullscreen-overlay-provider';
import { ErrorBoundary } from './general/errorBoundary';
import { ApiProvider } from './providers/api-provider';
import { AuthProvider } from './providers/auth-provider';
import { bookmarkReturnDestination } from './general/bookmark-destination';

import { AxiosInterceptor } from './general/axios-interceptor';
export { AxiosInterceptor } from './general/axios-interceptor';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([{ path: '*', element:
  <ErrorBoundary>
    <PrimeReactProvider>
      <FullscreenOverlayProvider>
        <AuthProvider>
          <ApiProvider>
            <AxiosInterceptor>
              <UnsavedChangesProvider><App /></UnsavedChangesProvider>
            </AxiosInterceptor>
          </ApiProvider>
        </AuthProvider>
      </FullscreenOverlayProvider>
    </PrimeReactProvider>
  </ErrorBoundary>
}]);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={Config.auth0.domain}
      clientId={Config.auth0.clientId}
      authorizationParams={{ redirect_uri: window.location.origin, audience: Config.auth0.audience }}
      cacheLocation="localstorage"
      onRedirectCallback={appState => {
        window.location.replace(bookmarkReturnDestination(appState?.returnTo));
      }}
    >
      <RouterProvider router={router} />
    </Auth0Provider>
  </React.StrictMode>
);
